import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchPlan: DocumentNode = gql`
  query FetchPlan($id: String!) {
    fetchPlan(id: $id) {
      ... on PlanResponse {
        autoRenew
        code
        currentlyOffered
        customFields {
          name
          value
        }
        intervalLength
        intervalUnit
        planProduct
        planSet
        trialLength
        trialUnit
        trialRequiresBillingInfo
        name
        currencies {
          currency
          unitAmount
        }
      }
      ... on PlanNotFound {
        error {
          message
          params {
            param
          }
          type
        }
      }
    }
  }
`

export default fetchPlan
